import { useState, useCallback } from 'react';
import { apiClient } from '../../utils/api';

type GenerationType = 'title' | 'problem';

// type GenerateResponse = {
//     success: boolean;
//     message: string;
//     data: {
//         generatedText?: string;
//         voice?: string;
//         text?: string;
//         timestamp: string;
//         requestId: string;
//     };
// };
type GenerateResultResponse = {
    success: boolean;
    message: string;
    data: {
        IsEthicsBan: boolean;
        voice?: string;
        text?: string;
        timestamp: string;
        requestId: string;
    };
};

export const useAiGenerate = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const generate = useCallback(async (promptText: string, generationType: GenerationType) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await apiClient.post<GenerateResultResponse>('/ai-generate', {
                promptText,
                generationType,
            });
            /* eslint-disable-next-line no-console */
            // console.log(response);

            return {
                title: response.data.IsEthicsBan ? response.message : response.data.text || '',
                description: response.data.IsEthicsBan ? response.message : response.data.text || '',
                isEthicsBan: response.data.IsEthicsBan,
            };
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Ошибка генерации';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, []);

    const generatePromptResult = useCallback(async (promptText: string) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await apiClient.post<GenerateResultResponse>('/ai-generate/result', {
                promptText,
            });
            /* eslint-disable-next-line no-console */
            // console.log(response);

            return {
                text: response.data.IsEthicsBan ? response.message : response.data.text || '',
                isEthicsBan: response.data.IsEthicsBan,
            };
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Ошибка генерации';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, []);

    return {
        generate,
        generatePromptResult,
        isLoading,
        error,
    };
};
